import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectErrors } from "selectors/errorSelector";
import ErrorBoundary from "components/ErrorBoundary";
import Main from "components/Main";
import { bindActionCreators } from "redux";
import { IntlProvider } from "react-intl";
import { getResourceFile } from "../../resources/index";
import { getSettings } from "AuthorizeLink/actions";
import { selectSettings } from "AuthorizeLink/selectors";

const mapStateToProps = state => {
  return {
    errors: selectErrors(state),
    settings: selectSettings(state)
  };
};
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettings: link => getSettings(link)
    },
    dispatch
  );
class MainContainer extends React.Component {
  static propTypes = {
    errors: PropTypes.array,
    settings: PropTypes.array
  };
  static defaultProps = {
    settings: ""
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.init();
  }
  init = async () => {
    const { getSettings } = this.props;
    const pathArray = window.location.pathname.split('/')
    const actionKey = pathArray[2];
    await getSettings(actionKey);
  };
  render() {
    const { errors, settings } = this.props;
    const intl = getResourceFile(settings);
    return (
      <IntlProvider locale="en" key="en" messages={intl.messages}>
        <ErrorBoundary>
          <Main errors={errors} />
        </ErrorBoundary>
      </IntlProvider>
    );
  }
}

MainContainer.propTypes = {
  /**Array of current errors */
  errors: PropTypes.array
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainContainer);
